export interface StyxInitConfig {
  serverHost?: string;
  writeKey?: string;
  token?: string;
  sendThrottleTime?: number;
  retryThrottleTime?: number;
  requestTimeout?: number;
  bulkSendLimit?: number;
  sessionIdKey?: string;
}

export interface StyxInstance {
  init(_config: Partial<StyxInitConfig>): void;
  track(
    _event: string,
    _properties?: Record<string, unknown>,
    _context?: Record<string, unknown>
  ): void;
  identify(_userId: string): void;
  reset(): void;
  page(
    _event: string,
    _properties: Record<string, unknown>,
    _context?: Record<string, unknown>
  ): void;
}

declare global {
  interface Window {
    sonicx: StyxInstance;
  }
}

let styxSessionId: string | null = null;

function getSonicx(): StyxInstance | null {
  return window.sonicx ?? null;
}

export function getAnalyticsSessionId(): string | null {
  return styxSessionId;
}

export function setAnalyticsSessionId(sessionId: string): void {
  styxSessionId = sessionId;
}

export function analyticsInit(config: Partial<StyxInitConfig>): void {
  console.log('[Styx] init', config);
  getSonicx()?.init(config);
}

export function analyticsTrack(
  event: string,
  properties?: Record<string, unknown>,
  context?: Record<string, unknown>
): void {
  console.log('[Styx] track', event, properties, context);
  getSonicx()?.track(event, properties, context);
}

export function analyticsPage(
  event: string,
  properties: Record<string, unknown>,
  context?: Record<string, unknown>
): void {
  console.log('[Styx] page', event, properties, context);
  getSonicx()?.page(event, properties, context ?? {});
}

export function analyticsIdentify(userId: number): void {
  console.log('[Styx] identify', userId);
  getSonicx()?.identify(String(userId));
}

export function analyticsReset(): void {
  console.log('[Styx] reset');
  getSonicx()?.reset();
}
